export { renderSpinButton_unstable as renderSpinButton } from '@fluentui/react-spinbutton';
